<template>
  <b-container fluid ondrop="return false;">
    
      <b-skeleton v-if="pageLoader"></b-skeleton>
      <app-header v-if="!isHideHeader"  />
      <app-navigation v-if="isToolBarVisible" />
      <b-row class="ma-0 pa-0" v-if="isPublic">
        <b-col class="pa-0 ma-0">
          <router-view></router-view>
        </b-col>
      </b-row>
      <b-row class="ma-0 pa-0" v-else>
        <b-col class="pa-0 ma-0" style="
          border-right: 2px solid #eee;
          height: calc(100vh - 48px);
          overflow: auto;
        ">
          <router-view></router-view>
        </b-col>
      </b-row>
      <b-sidebar :visible="sidebar.show" right style="top:64px !important" no-header>
        asdad 
        <template #footer>
          HEllo
        </template>
      </b-sidebar>
      <modal-basic />
      <project-sidebar />
  </b-container>
</template>
<script>
import ProjectSidebar from "@/components/ProjectSidebar"
import AppNavigation from './components/AppNavigation';
import { mapGetters } from 'vuex';
import AppHeader from './components/AppHeader.vue';
import { ModalBasic } from './components/styled/modals';

export default {
  name: 'App',
  components: {
    AppHeader,
    ModalBasic,
    AppNavigation,
    ProjectSidebar
  },
  computed: {
    ...mapGetters({
      sidebar:  'ui/sidebar',
      pageLoader: 'app/pageLoader',
      isToolBarVisible: 'app/isToolBarVisible',
    }),
    isHideHeader(){
      return this.$route.meta.hideHeader
    },

    isPublic(){
      return this.$route.meta.isPublicAuthenticatedPage
    }
  },
  mounted(){
    this.$i18n.locale = this.$store.getters['session/lang']
  }
  
};
</script>
<style lang="scss">
@import "~@/assets/scss/vendors/bootstrap-vue/index";
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

.b-skeleton-text{
  margin-left:-20px;
  margin-right:-20px;
  background:#0883c5;
  height:0.3rem;
  border-radius: 0;
}
.b-skeleton{
  position: absolute;
  top:0;
  left:20px;
  width: 100%;
  z-index: 100000;
}
</style>
